"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CenterComponent = void 0;
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
const _excluded = ["width", "height", "bg", "borderRadius", "boxShadow", "borderWidth", "borderStyle", "borderColor", "margin", "padding"];
const CenterComponent = exports.CenterComponent = _styledComponents.default.div`
	${_ref => {
  let {
      width,
      height,
      bg,
      borderRadius,
      boxShadow,
      borderWidth,
      borderStyle,
      borderColor,
      margin,
      padding
    } = _ref,
    props = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
  return `
    width: ${width};
    height: ${height};
    background: ${bg}; 
    border-radius: ${borderRadius};
    display: flex;
	align-items: center;
	justify-items: space-between;
	justify-content: center;
    ${boxShadow};
    border-width:${borderWidth}px;
    border-style:${borderWidth ? borderStyle || 'solid' : ''};
    border-color:${borderColor};
    margin: ${margin};
    padding:${padding};
    }
`;
}}
`;